import AwardsSection from "@components/new-ui/AwardsSection";
import CaseStudyFeatureSection, { Feature } from "@components/new-ui/CaseStudyFeatureSection";
import ClientLogos, { LogoObject } from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import Herosection, { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import ProductSection, { Product } from "@components/new-ui/IndustriesSection/ProductSection";
import StatsInfo, { StatsInfoProps } from "@components/new-ui/IndustriesSection/StatsInfo";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import { processEnv } from "@lib/processEnv";
import { IIndustries } from "@pages/industry/finance/whatsapp";
import { windowOpenNewTab } from "@utils/common";
import axios from "axios";
import { GetStaticProps } from "next";
import Image from "next/image";
import React from "react";
import { MdOutlineArrowForwardIos } from "react-icons/md";

const featureInfo1: FeatureInfo = {
    mainTitle: "Craft memories, not just experiences",
    subtitle: "With personalized, thoughtful travel suggestions",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/travel/travel-recommendation.png",
    featureInfoList: ["Instant destination recommendations", "Real-time price and availability checks", "Personalized itinerary planning", "Smart travel package suggestions"],
};

const featureInfo2: FeatureInfo = {
    mainTitle: "Make travel planning effortless",
    subtitle: "Because adventures should start with excitement, not stress",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/travel/travel-sequence-flow.png",
    featureInfoList: ["Automated booking confirmations", "Digital document collection", "Weather and travel updates", "Local experience recommendations"],
};

const featureInfo3: FeatureInfo = {
    mainTitle: "Support travelers from planning to execution",
    subtitle: "By providing customers a smooth pre-travel experience",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/travel/plan-ugrade.png",
    featureInfoList: ["Real-time flight updates", "Local transportation assistance", "Travel insurance and visa guidance", "24x7 emergency travel assistance"],
};

const featureInfo4: FeatureInfo = {
    mainTitle: "Delight without the complexity",
    subtitle: "By letting AI and automation handle the heavy lifting",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/travel/razorpay-integration.png",
    featureInfoList: ["Multi-language travel support", "Automated check-in reminders", "Group travel coordination", "Travel package payments"],
};

const featureInfo5: FeatureInfo = {
    mainTitle: "Build interest with potential travelers",
    subtitle: "With ready-to-use message templates for travel",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/travel/whatsapp-template.png",
    featureInfoList: [
        "Broadcasting in-demand tourist packages",
        "Off-season destination recommendations",
        "Tailored business travel offers",
        "Segmented campaigns based on travel history",
    ],
};

const ecommerceProductCardData: Array<Product> = [
    {
        title: "Click-to-WhatsApp ads",
        description: "Convert interested prospects into travelers directly from Meta ads.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/click-whatsapp-ads.png",
        externalLink: "https://gallabox.com/click-to-whatsapp-ads",
    },
    {
        title: "Broadcast",
        description: "Send timely travel updates and offers based on customer segments",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/broadcast.png",
        externalLink: "https://gallabox.com/whatsapp-broadcast",
    },
    {
        title: "Drip marketing",
        description: "Nurture potential customers by scheduling destination content and time-sensitive deals",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/drip-marketing.png",
        externalLink: "https://gallabox.com/whatsapp-drip-marketing",
    },
    {
        title: "Flows",
        description: "Collect booking information and preferences seamlessly, in a few taps",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/whatsapp-flow.png",
        externalLink: "https://gallabox.com/whatsapp-flows",
    },
    {
        title: "Chatbot",
        description: "Handle travel queries and booking FAQs with our no-code AI chatbots",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/bot.png",
        externalLink: "https://gallabox.com/whatsapp-chatbot",
    },
    {
        title: "Shared team inbox",
        description: "Never let enquiries go unanswered, with intuitive routing and team inbox",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/inbox.png",
        externalLink: "https://gallabox.com/whatsapp-shared-inbox",
    },
    {
        title: "AI rewrite",
        description: "Edit your responses with our Gen AI and communicate with travelers in multiple languages",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/gallabox-gen-ai.png",
        externalLink: "https://gallabox.com/whatsapp-ai-chatbot",
    },
    {
        title: "Payments",
        description: "Process bookings and send payment confirmations automatically on WhatsApp",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/group.png",
        externalLink: "https://gallabox.com/whatsapp-payments",
    },
];

const herosectionData: HerosectionProps = {
    chipTitle: "TRAVEL",
    title: "Scale travel bookings by 67% with Gallabox's WhatsApp automations",
    description:
        "Make every journey unforgettable – from first inquiry to final checkout. Transform trip planning, itineraries, booking, and travel support with Gallabox’s WhatsApp automations.",
    primaryButtonText: "Try for Free",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/travel/travel-hero-image.png",
};

const statsInfoData: Array<StatsInfoProps> = [
    { percentage: "67%", label: "Increase in travel bookings" },
    { percentage: "43%", label: "Higher team productivity" },
    { percentage: "71%", label: "Growth in revenue" },
];
const caseStudyFeatureCardData: Array<Feature> = [
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/industries/travel/pickyourtrail.png",
        chiptitle: "EDUCATION",
        title: "Gallabox powers Pickyourtrail's WhatsApp marketing success",
        statsInfoData: [
            { percentage: "77%", label: "Increase in lead generation" },
            { percentage: "70%", label: "Business growth impact" },
            { percentage: "40%", label: "Higher team productivity" },
        ],
        url: "https://gallabox.com/case-study/pickyourtrail",
    },
];

const clientLogosData: LogoObject[] = [
    { url: "https://assets.gallabox.com/gb-home/industries/travel/bigred.svg", alt: "bigred", width: 120, height: 60 },
    { url: "https://assets.gallabox.com/gb-home/industries/travel/driveo.svg", alt: "driveo", width: 120, height: 48 },
    { url: "https://assets.gallabox.com/gb-home/industries/travel/gct.svg", alt: "gct", width: 120, height: 48 },
    { url: "https://assets.gallabox.com/gb-home/industries/travel/kaadgal.svg", alt: "kaadgal", width: 120, height: 48 },
    { url: "https://assets.gallabox.com/gb-home/industries/travel/malnad.svg", alt: "malnad", width: 120, height: 40 },
    { url: "https://assets.gallabox.com/gb-home/industries/travel/mango.svg", alt: "mango", width: 120, height: 90 },
    { url: "https://assets.gallabox.com/gb-home/industries/travel/ntsa.svg", alt: "ntsa", width: 120, height: 38 },
    { url: "https://assets.gallabox.com/gb-home/industries/travel/pickyourtrail.svg", alt: "pickyourtrail", width: 120, height: 60 },
    { url: "https://assets.gallabox.com/gb-home/industries/travel/skyplanet.svg", alt: "skyplanet", width: 120, height: 90 },
    { url: "https://assets.gallabox.com/gb-home/industries/travel/thrillopilia.svg", alt: "thrillopilia", width: 120, height: 31 },
    { url: "https://assets.gallabox.com/gb-home/industries/travel/tvista.svg", alt: "tvista", width: 120, height: 76 },
    { url: "https://assets.gallabox.com/gb-home/industries/travel/vacation.svg", alt: "vacation", width: 120, height: 51 },
    { url: "https://assets.gallabox.com/gb-home/industries/travel/working.svg", alt: "working", width: 120, height: 51 },
];

const TravelLanding: React.FC<IIndustries> = ({ categoryResult }) => {
    return (
        <NewLayout
            description="Discover AI-powered WhatsApp automation solutions for travel businesses. Boost bookings by 67% on WhatsApp with Gallabox automations."
            title="AI WhatsApp Automation Solutions for Travel & Tourism "
            canonical="https://gallabox.com/industry/travel/whatsapp"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/industries/travel/travel-og.png" }}
            schema={{
                heroOrOgImageAlt: "travel-image",
                heroOrOgImageDescription: "Scale travel bookings by 67% with Gallabox's WhatsApp automations",
                heroOrOgImageUrl: "https://assets.gallabox.com/gb-home/industries/professional-services/professional-services.png",
                softwareFeatureName: "travel",
            }}
        >
            <Herosection herosection={herosectionData} />
            <StatsInfo statsInfo={statsInfoData} />
            <section className={`${container_classname} my-10`}>
                <h3 className="text-center text-lg font-normal py-5">TRUSTED BY 10,000+ BUSINESSES</h3>
                <ClientLogos logos={clientLogosData} />
            </section>
            <FeatureInfoCard {...featureInfo1} />
            <FeatureInfoCard {...featureInfo2} />
            <FeatureInfoCard {...featureInfo3} />
            <FeatureInfoCard {...featureInfo4} />
            <FeatureInfoCard {...featureInfo5} />
            <ProductSection
                productCardData={ecommerceProductCardData}
                title="Transform your travel communication"
                description="Essential features to revolutionize travel on WhatsApp"
            />

            <section className={`${container_classname} py-20`}>
                <h2 className="md:text-6xl text-4xl mb-12" style={{ fontFamily: "Degular Display" }}>
                    Ready-to-test travel chatbot templates
                </h2>
                <div className={"grid md:grid-cols-3 md:gap-5 gap-10"}>
                    {categoryResult.slice(0, 3).map((data: any) => (
                        <div
                            key={data.id}
                            className="border border-solid border-gray-200 rounded cursor-pointer"
                            onClick={() => windowOpenNewTab(`/whatsapp-chatbot-templates/${data.category}/${data.title}/${data.id}`)}
                        >
                            <div className="relative">
                                <Image src={data.picture} alt={data.title} width={280} height={170} style={{ height: "200px" }} className="w-full" />

                                <div
                                    className="absolute top-0 left-0 w-full h-full"
                                    style={{
                                        background: "linear-gradient(180deg, rgba(51, 100, 250, 0.00) 0%, rgba(51, 100, 250, 0.12) 100%)",
                                    }}
                                ></div>
                            </div>
                            <div className="p-8 bg-white">
                                {data.tags?.length > 0 && (
                                    <p className="mb-4 text-gray-700 text-sm">{data.tags.map((tag: { name: string }) => tag.name.toUpperCase()).join(" / ")}</p>
                                )}
                                <div className="h-24">
                                    <p className="mb-12 text-2xl font-medium">{data.title}</p>
                                </div>
                                <div className="flex gap-x-4 items-center">
                                    <a
                                        href={`/try-template/${data.id}`}
                                        className="border border-solid border-blue-600 text-blue-600 rounded no-underline hover:no-underline text-sm"
                                        style={{ lineHeight: "14px", padding: "8px 12px 8px 12px" }}
                                    >
                                        TRY
                                    </a>
                                    <div className="flex gap-1 items-center">
                                        <Image src="/new-industries/education/view.svg" width={20} height={20} className="w-8 h-6" alt="visited" />
                                        {data.usedCount}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <p className="mt-9 text-blue-500 flex justify-center">
                    <a href="https://gallabox.com/whatsapp-chatbot-templates/education" className="flex items-center gap-x-2">
                        View all <MdOutlineArrowForwardIos size={14} />
                    </a>
                </p>
            </section>

            <CaseStudyFeatureSection features={caseStudyFeatureCardData} />
            <IntegrationSection isLight={true} />
            <AwardsSection />
            <CTASection title="Help your customers visualize their dream vacation on WhatsApp." description="Take Gallabox for a 7-day ride" />
        </NewLayout>
    );
};

export default TravelLanding;

export const getStaticProps: GetStaticProps = async () => {
    let categoryResult;

    try {
        await axios({
            method: "get",
            url: "https://server.gallabox.com/devapi/bot-templates",
            headers: {
                apiSecret: process.env.REACT_APP_API_SECRET,
                apiKey: process.env.REACT_APP_API_KEY,
            },
            data: {
                status: "published",
                category: "travel",
            },
        })
            .then(function (response) {
                categoryResult = JSON.parse(JSON.stringify(response?.data)) || [];
            })
            .catch(function (err) {
                console.log(err);
            });
    } catch (error) {
        throw new Error("Index creation failed.");
    }

    return {
        props: { categoryResult },
        ...(processEnv.isr.enable && { revalidate: 1 }),
    };
};
